import { render } from "./VideoShow.vue?vue&type=template&id=e2e16422&scoped=true"
import script from "./VideoShow.vue?vue&type=script&lang=js"
export * from "./VideoShow.vue?vue&type=script&lang=js"

import "./VideoShow.vue?vue&type=style&index=0&id=e2e16422&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e2e16422"]])

export default __exports__